module.exports = __webpack_public_path__ + "media/images/upload_3-499a4c9a.png";